import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { setupRedux } from "./redux/store";
import { ConnectedRouter } from "connected-react-router";
import { PersistGate } from "redux-persist/integration/react";
import { Route, Switch, Redirect } from "react-router-dom";
import { AuthProvider } from "react-oidc-context";
import { initSentry } from "./sentry";
import { appConfig } from "appConfig";
import { userManager, onSigninCallback } from "./services/oidc";
import "bootstrap/dist/css/bootstrap.min.css";
import "assets/sass/light-bootstrap-dashboard-pro-react.scss?v=1.2.0";
import "assets/css/demo.css";
import "assets/css/pe-icon-7-stroke.css";
import "assets/css/custom.css";
import AdminLayout from "layouts/Admin.jsx";
import AuthGate from "./components/AuthGate";
import { AppErrorBoundary } from "./components/ErrorBoundary/ErrorBoundary";
// Initialize Sentry
initSentry(appConfig.sentry);

// Initialize Redux
const { store, persistor, history } = setupRedux();

const App = ({ store, persistor, history }) => {
  return (
    <AppErrorBoundary>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <AuthProvider
            userManager={userManager}
            onSigninCallback={onSigninCallback}
          >
            <AuthGate history={history}>
              <Router history={history} />
            </AuthGate>
          </AuthProvider>
        </PersistGate>
      </Provider>
    </AppErrorBoundary>
  );
};

const Router = ({ history }) => {
  return (
    <ConnectedRouter history={history}>
      <Switch>
        <Route path="/admin" render={(props) => <AdminLayout {...props} />} />
        <Redirect from="/" to="/admin/briefing-room" />
      </Switch>
    </ConnectedRouter>
  );
};

ReactDOM.render(
  <App store={store} persistor={persistor} history={history} />,
  document.getElementById("root")
);
